<template>
  <div>
    <div class="select-payment">
      <div v-if="Object.keys(selectedCard).length > 0" class="has-payment">
        <img
          :src="
            selectedCard.card_org ||
            selectedCard.icon_url ||
            selectedCard.cardOrg
          "
          class="ic-card"
          alt=""
        />
        <span
          class="card-num"
          v-if="selectedCard.card_suffix || selectedCard.cardSuffix"
          >{{
            (selectedCard.card_suffix || selectedCard.cardSuffix) | cardFilter
          }}</span
        >
        <span class="card-num" v-if="!selectedCard.card_suffix">{{
          selectedCard.payment_name || selectedCard.channelName
        }}</span>
      </div>
      <span
        v-else
        class="no-payment"
        :class="noHasPayment ? 'no-payment-tips' : ''"
        >{{ $t('请选择支付方式') }}</span
      >
      <i class="icon-outline_entrance"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'payWaysBtn',
  data() {
    return {};
  },
  props: {
    noHasPayment: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      selectedCard: ({ pay }) => pay.selectedCard,
    }),
  },
  filters: {
    // 取卡号后4位
    cardFilter(card) {
      return String(card).slice(-4) || '';
    },
  },
  mounted() {},
  methods: {
    selectPayment(index) {
      this.$emit('selectpayment', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-payment {
  font-family: 'Aspira Medium';
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  .has-payment {
    display: flex;
    align-items: center;
  }
  .ic-card {
    // width: 22px;
    height: 16px;
    border-radius: 2px;
    position: relative;
  }
  .card-num {
    margin-left: 5px;
    font-family: 'Aspira Medium';
    font-size: 16px;
    color: #000;
    position: relative;
    top: 1px;
  }
  .no-payment {
    display: flex;
    align-items: center;
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 16px;
    color: #ccc;
    position: relative;
    top: 1px;
  }
  .no-payment-tips {
    color: #ff4e45;
  }
  .icon-outline_entrance {
    font-size: 14px;
    margin-left: 8px;
    position: relative;
  }
}
@media screen and (max-width: 768px) {
  .select-payment {
    .ic-card {
      width: rem(69);
      height: rem(42);
      border-radius: rem(6);
      top: rem(1);
    }
    .card-num {
      margin-left: rem(8);
      font-size: rem(36);
    }
    .no-payment {
      font-size: rem(28);
    }
    .icon-outline_entrance {
      top: rem(2);
      font-size: rem(28);
    }
  }
}
</style>